import type {ScheduleItem} from '@domain/schedule'
import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import {Stack, Typography} from '@mui/material'
import {useCurrentTimeRounded} from '@widgets/stock-card'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {PlannerSwitch} from '../formComponents'

interface ScheduleItemTransitionTimeSwitchProps {
  scheduleItem: ScheduleItem
  handleTransitionTimeChange: (isTransitionTime: boolean, shouldSplit: boolean) => void
}
export const ScheduleItemTransitionTimeSwitch: React.FC<ScheduleItemTransitionTimeSwitchProps> = ({
  scheduleItem,
  handleTransitionTimeChange
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezoneId = useUpmPlantTimezone()
  const nowRounded = useCurrentTimeRounded({timezoneId, roundingFn: roundTo15MinIntervalStart})
  const isTransitionTimeChangeDisabled = moment.utc(scheduleItem.end).isBefore(nowRounded)
  const shouldDisplaySplitWarning = moment.utc(scheduleItem.start).isBefore(nowRounded)

  const onTransitionTimeChange = (isChecked: boolean) =>
    handleTransitionTimeChange(isChecked, shouldDisplaySplitWarning)

  return (
    <PlannerSwitch
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <SwapHorizIcon />
          <Typography>{t('planning.transitionTime')}</Typography>
        </Stack>
      }
      value={scheduleItem.isTransitionTime}
      onChange={onTransitionTimeChange}
      disabled={isTransitionTimeChangeDisabled}
      {...dataTestId('transition_time_toggle')}
    />
  )
}
